import { createActions, createReducer } from 'reduxsauce'

import ExerciciosDotacaoService from '../servicos/ExerciciosDotacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaExercicioInicio: [],
    buscaExercicioSucesso: ['exercicio'],
    buscaExercicioErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaExercicio = () => {
    return dispatch => {
        dispatch(Creators.buscaExercicioInicio())
        let serv = new ExerciciosDotacaoService()
        return serv
            .getExercicios()
            .then(response => dispatch(Creators.buscaExercicioSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaExercicioErro(error)))
    }
}

const buscaExercicioInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaExercicioErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaExercicioSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.exercicio, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EXERCICIO_INICIO]: buscaExercicioInicio,
    [Types.BUSCA_EXERCICIO_ERRO]: buscaExercicioErro,
    [Types.BUSCA_EXERCICIO_SUCESSO]: buscaExercicioSucesso,
})
